module.exports = "<!-- Footer -->\n<sq-footer />\n";